import React from 'react';
import { Box, Typography } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { getFallbackMakeLogoImage } from '../../utils/carLogo/getFallbackMakeLogoImage';

const COLLAPSED_HEIGHT = 215;
const MAX_VISIBLE_GENERATIONS = 4;

const UserFilters = ({ userFiltersData, expandedFilter, handleToggleExpand, onClick }) => {
  return (
    <div style={styles.container}>
      {userFiltersData.length > 0 ? (
        userFiltersData.map((filter, index) => {
          const isExpanded = expandedFilter === index;

          let generationCounter = 0;
          const allGenerations = [];

          filter.models.forEach((model) => {
            if (model.generations?.length > 0) {
              model.generations.forEach((generation) => {
                allGenerations.push(generation.name || 'N/A');
              });
              generationCounter += model.generations.length;
            }
          });

          const showExpandOption = generationCounter > MAX_VISIBLE_GENERATIONS;
          const generationsToShow = isExpanded ? allGenerations : allGenerations.slice(0, MAX_VISIBLE_GENERATIONS);

          return (
            <Box key={index} sx={{ ...styles.box, ...styles.dynamicBox(isExpanded) }}>
              <Box sx={styles.innerBox} onClick={onClick}>
                <Box sx={styles.headerBox}>
                  <img
                    src={getFallbackMakeLogoImage(filter?.name)}
                    alt={filter.name || 'Logo'}
                    style={styles.logoImage}
                  />
                  <Typography variant="h5">{filter.name || 'N/A'}</Typography>
                </Box>

                {generationsToShow.map((generation, genIndex) => (
                  <Box key={genIndex} sx={styles.generationBox}>
                    <Typography variant="body2" sx={styles.generationText}>
                      {generation}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {showExpandOption && (
                <Box sx={styles.expandBox} onClick={() => handleToggleExpand(index)}>
                  {isExpanded ? (
                    <>
                      <Typography variant="body2" sx={styles.expandText}>
                        Prikaži manje
                      </Typography>
                      <ExpandLess />
                    </>
                  ) : (
                    <>
                      <Typography variant="body2" sx={styles.expandText}>
                        Još {generationCounter - MAX_VISIBLE_GENERATIONS} generacija...
                      </Typography>
                      <ExpandMore />
                    </>
                  )}
                </Box>
              )}
            </Box>
          );
        })
      ) : (
        <Typography variant="body2">Nema filtera</Typography>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '20px',
    marginLeft: 40
  },
  box: {
    backgroundColor: 'rgba(243, 244, 246, 1)',
    padding: '20px',
    borderRadius: '8px',
    width: '350px',
    boxShadow: '0 0 6px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.3s ease',
    border: '1px solid',
  },
  dynamicBox: (isExpanded) => ({
    maxHeight: isExpanded ? 'none' : `${COLLAPSED_HEIGHT}px`,
    overflowY: isExpanded ? 'visible' : 'auto',
  }),
  innerBox: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  logoImage: {
    width: '50px',
    height: '50px',
    marginRight: '15px',
  },
  generationBox: {
    paddingLeft: '10px',
    marginBottom: '6px',
  },
  generationText: {
    color: '#555',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },
  expandBox: {
    marginTop: 'auto',
    paddingTop: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'rgba(91, 33, 182, 1)',
    backgroundColor: 'rgba(243, 244, 246, 1)',
    padding: '6px 10px',
    mt: 2,
  },
  expandText: {
    fontWeight: 500,
    marginRight: '6px',
  },
};

export default UserFilters;
